import { CommonEventProperties, SelfDescribingEvent } from '@snowplow/browser-tracker';
import {
  GeniallyContext,
  SpaceContext,
  UserContext,
  WorkspaceContext,
  WorkspaceMemberContext,
} from '@genially/snowplow-contracts';

import { mapAllContextsAsArray } from '../utils/mapAllContextsAsArray';

enum DisplayHtmlAsOptions {
  TITLE_1 = 'title_1',
  TITLE_2 = 'title_2',
  SUBTITLE = 'subtitle',
  CONTENT = 'content',
}

export const getTextStyleEditedEvent = ({
  user,
  team,
  teamMember,
  space,
  genially,
  text_style,
}: {
  user: UserContext;
  team?: WorkspaceContext;
  teamMember?: WorkspaceMemberContext;
  space?: SpaceContext;
  genially?: GeniallyContext;
  text_style: DisplayHtmlAsOptions;
}): SelfDescribingEvent & CommonEventProperties => ({
  event: {
    schema: 'iglu:com.genially/text_style_edited/jsonschema/1-0-0',
    data: { text_style },
  },
  context: mapAllContextsAsArray({ user, team, teamMember, space, genially }),
});
